import isPropValid from "@emotion/is-prop-valid";
import styled from "styled-components";
import boxMixin from "../../../mixins/box";
export const LazyLoadingBox = styled.div.withConfig({
    shouldForwardProp: isPropValid,
}) `
  ${boxMixin};
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiTGF6eUxvYWRpbmdCb3guanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9Cb3gvc3R5bGVkL0xhenlMb2FkaW5nQm94LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE9BQU8sV0FBVyxNQUFNLHdCQUF3QixDQUFDO0FBQ2pELE9BQU8sTUFBTSxNQUFNLG1CQUFtQixDQUFDO0FBQ3ZDLE9BQU8sUUFBMkIsTUFBTSxxQkFBcUIsQ0FBQztBQUU5RCxNQUFNLENBQUMsTUFBTSxjQUFjLEdBQUcsTUFBTSxDQUFDLEdBQUcsQ0FBQyxVQUFVLENBQUM7SUFDbEQsaUJBQWlCLEVBQUUsV0FBVztDQUMvQixDQUFDLENBQWU7SUFDYixRQUFRO0NBQ1gsQ0FBQyJ9